import { render, staticRenderFns } from "./system-notice.vue?vue&type=template&id=e4e99cb0&"
import script from "./system-notice.vue?vue&type=script&lang=js&"
export * from "./system-notice.vue?vue&type=script&lang=js&"
import style0 from "./system-notice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports